"use strict";

function getObjectId(result){
    /* Search service returns 'id' as {object_type}{object_id} concatenated
    *  e.g. object_type 3, object_id 421 = 3421 */
    return result.id.replace(result.object_type, '');
}

function selectFilter(context, filterName, filterValue) {
    context.applyFilter(filterName, filterValue, {replaceAll: true});
    context.pushState({
        'buttonSelector': 'button[data-filter-name="' + filterName + '"]',
        'buttonState': 'selected'
    });

    // Close the dropdown
    var $button = context.buttonbarNode.find('button[data-filter-name="' + filterName + '"]');
    $button.parent().removeClass("open");
}

function clearFilter(context, filterName) {
    context.removeFilter(filterName);
    context.pushState({
        'buttonSelector': 'button[data-filter-name="' + filterName + '"]',
        'buttonState': 'unselected'
    });

    // Remove the filter button highlight
    var $button = context.buttonbarNode.find('button[data-filter-name="' + filterName + '"]');
    $button.addClass("btn-default");
    $button.removeClass("btn-selected");

    // Close the dropdown
    $button.parent().removeClass("open");
}

var CUSTOM_FILTER_LIST = ['account_legal_name', 'contact']
function initInputFilters(context) {
    context.buttonbarNode.find('input[data-select2-for]').each(function(){
        var $node = $(this)
        var filterName = $node.data('select2-for');
        var ajaxUrl = $node.data('select2-ajax-url');
        var objectType = $node.data('select2-object-type');
        var field = $node.data('select2-field');
        
        var options = {
            allowClear: true,
            dropdownAutoWidth: true,
        }
        if (ajaxUrl) {
            options.minimumInputLength = 1;
            options.ajax = {
                url: ajaxUrl,
                data: function (term) {
                    return field ? {q: term, t: objectType, f: field} : {q: term, t: objectType} 
                },
                results: function (data) {
                    var namesAppeared = []
                    var results =  data.results.map(function (result) {
                        var company_name = result.company_name ? '(' + result.company_name + ')' : '';
                        
                        // for "account legal name" and "contact" filter, filter out duplicated name
                        if (CUSTOM_FILTER_LIST.indexOf(filterName) !== -1) {
                            if (namesAppeared.indexOf(result.label) !== -1) {
                                return null;
                            }
                            namesAppeared.push(result.label);
                        }
                
                        return {
                            id: CUSTOM_FILTER_LIST.indexOf(filterName) !== -1 ? result.label : getObjectId(result),
                            text: CUSTOM_FILTER_LIST.indexOf(filterName) !== -1 ? result.label : (result.label + ' ' + company_name).trim()
                        };
                    }).filter(function (result) { return !!result; });

                    return { results: results };
                },
            }
        }

        $node.select2(options);

        $node.on('select2-selecting', function(e) {
            var filterValue = e.object.id;
            selectFilter(context, filterName, filterValue);
        });

        $node.on('select2-clearing', function(e) {
            clearFilter(context, filterName);
        });

        // Focus inside the select2 on dropdown open
        var button = context.buttonbarNode.find('button[data-filter-name="' + filterName  + '"]');
        button.parent().on('shown.bs.dropdown', function() {
            $node.select2('open');
        });
    });
}

define('components/filter_bar/filters/select2_filters',[], function() {
    var select2FiltersComponent = {
        initWithContext: function(context) {
            _initData(context);

            // Initialize all select2 components
            initInputFilters(context);
            context.select2FiltersData.selectNodes.each(function(){
                var $node = $(this);
                var filterName = $node.data('select2-for');

                $node.select2({
                    allowClear: true,
                    dropdownAutoWidth: true,
                });

                $node.on('select2-selecting', function(e) {
                    var filterString = $(e.object.element).data('filter');
                    var parts = filterString.split('=');
                    var filterValue = parts[parts.length - 1]
                    selectFilter(context, filterName, filterValue);
                });

                $node.on('select2-clearing', function(e) {
                    clearFilter(context, filterName);
                });

                // Focus inside the select2 on dropdown open
                var button = context.buttonbarNode.find('button[data-filter-name="' + filterName  + '"]');
                button.parent().on('shown.bs.dropdown', function() {
                    $node.select2('open');
                });
            });
        },

        resetToDefaultUI: function(context) {
            context.select2FiltersData.selectNodes.select2('data', null);
            context.select2FiltersData.inputNodes.select2('data', null);
        }
    };

    function _initData(context) {
        context.select2FiltersData = {
            selectNodes: context.buttonbarNode.find('select[data-select2-for]'),
            inputNodes: context.buttonbarNode.find('input[data-select2-for]'),
        };
    }

    return select2FiltersComponent;
});
